import React, { useContext } from 'react';
import {
	DishFullInfoContext,
	IDishFullInfoContext,
} from '../../../../../../../../../dishFullInfoState/dishFullInfoContext';
import Text from 'components/Text/Text';
import ChunkOfTextWithCopying from 'components/Text/ChunkOfTextWithCopying';
import style from './DishModificationsField.module.scss';

const DishModificationsField: React.FC = () => {
	const { dishForFullInfo } = useContext<IDishFullInfoContext>(DishFullInfoContext);

	return (
		<div className={style.container}>
			<Text
				translationNameSpace="form"
				translationKey="dishModificationsCountLabel"
				translationOptions={{ count: dishForFullInfo?.dishModifications.length }}
				theme="neutralLight"
				size="xs"
			/>
			<div className={style.modificationsList}>
				{dishForFullInfo?.dishModifications?.length
					? dishForFullInfo.dishModifications.map((el) => {
							const translationKey = el.showInCombo ? 'showInComboLabel' : 'hiddenFromComboLabel';
							return (
								<div key={el.modificationId} className={style.item}>
									<div className={style.dot} />
									<Text translationKey={el.modificationName} size="s" withTooltip={true} />
									<div className={style.additionalContent}>
										<Text
											translationNameSpace="form"
											translationKey={translationKey}
											theme="secondary"
											size="s"
											weight="bold"
										/>
									</div>
									{el.externalId && (
										<ChunkOfTextWithCopying text={el.externalId} className={style.externalId} />
									)}
								</div>
							);
					  })
					: '-'}
			</div>
		</div>
	);
};

export default DishModificationsField;
